import { Serializable } from "./serializable";

export default class Address implements Serializable<Address> {
  id?: string = undefined;
  street?: string = "";
  zipCode?: string = "";
  city?: string = "";
  province?: string = "";
  region?: string = "";
  state?: string = "";
  lat?: string = "";
  lng?: string = "";

  deserialize(input: any): Address {
    if (input != null) {
      this.id = input.id || null;
      this.street = input.street;
      this.zipCode = input.zipcode || null;
      this.city = input.city || null;
      this.province = input.province || null;
      this.region = input.region || null;
      this.state = input.state || null;
      this.lat = input.lat || null;
      this.lng = input.lng || null;
    }
    return this;
  }

  userRequestSerialize(input: any): any {
    return {
      id: input.id,
      zipcode: input.zipCode,
      street: input.street,
      city: input.city,
      province: input.province,
      state: input.state
    };
  }
}
